import { Button, Form, message, Modal, Select, TreeSelect } from 'antd';

import './styles.css';
import { useAuthStore } from '../../../../../../../../store/auth/auth';
import { useGroupsStore } from '../../../../../../../../store/groups/Groups';
import { DeviceByGroupStore } from '../../../../../../../../store/devices/DeviceByGroupStore';
import React, { useEffect, useState } from 'react';
import { UpdateLayouts } from '../../../../../../../../api/layout/UpdateLayout';
import { Group } from '../../../../../../../../types/Group';
import { CloseOutlined } from '@ant-design/icons';
import { LayoutType } from '../../../../../../../../types/LayoutType';
import { useLayoutsStore } from '../../../../../../../../store/layout/useLayoutsStore';
import { useSelectedLayout } from '../../../../../../../../store/useSelectedLayout';
import { Device } from '../../../../../../../../types/Device';
const { TreeNode } = TreeSelect;

const { Option } = Select;

export interface AddDeviceModalProps {
    visible: boolean;
    onOk: () => void;
    onCancel: () => void;
    title: string;
    setIsModalVisible: (visible: boolean) => void;
    layout: LayoutType;
    existingDevices: string[];
    layoutBool?: boolean;
}

export const AddDeviceModal: React.FC<AddDeviceModalProps> = ({
    visible,
    onCancel,
    onOk,
    setIsModalVisible,
    layout,
    existingDevices,
    layoutBool,
}) => {
    const { user, SmartDVRToken } = useAuthStore();
    const { groups, fetchGroups } = useGroupsStore();
    const { devicesByStore, fetchDevicesByStore, fetchAllDevices, allDevices } =
        DeviceByGroupStore();
    const [selectedGroup, setSelectedGroup] = useState<string | undefined>(undefined);
    const [selectedDevices, setSelectedDevices] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const { allLayouts, fetchLayouts } = useLayoutsStore();
    const { selectedLayout, setSelectedLayout } = useSelectedLayout();
    console.log('existingDevices', existingDevices);

    // Загрузка групп и установка устройств
    useEffect(() => {
        if (visible) {
            fetchGroups();
            fetchAllDevices(SmartDVRToken, user?.login!);

            console.log('Setting selected devices:', existingDevices);
            setSelectedDevices(existingDevices || []);
        }
    }, [visible, user]);

    const handleGroupChange = async (value: string) => {
        setSelectedGroup(value);
        if (value && user) {
            setLoading(true);
            await fetchDevicesByStore(value, SmartDVRToken, user.login);
            setLoading(false);
        }
    };

    const handleDeviceChange = (newDevices: string[]) => {
        const uniqueNewDevices = newDevices?.filter((uid) => !existingDevices?.includes(uid));

        setSelectedDevices([...(existingDevices ?? []), ...uniqueNewDevices]);
    };

    const handleOk = async () => {
        console.log(layout);
        if (!layout?.uid) {
            message.error('UID раскладки не найден.');
            return;
        }

        const devicesToAdd = selectedDevices.filter(
            (deviceUID) => !existingDevices?.includes(deviceUID),
        );

        if (devicesToAdd.length === 0) {
            message.warning('Выбранные устройства уже есть в раскладке');
            return;
        }

        const devicesData = [...(existingDevices ?? []), ...devicesToAdd].map((deviceUID) => ({
            UID: deviceUID,
        }));

        const data = {
            uid: layout?.uid,
            devices: devicesData,
        };
        // console.log(allDevices);
        // console.log(devicesData);
        try {
            if (user) {
                setLoading(true);
                const response = await UpdateLayouts(SmartDVRToken, user.login, data);

                console.log(response);
                if (response.success) {
                    message.success(`Добавлено ${devicesToAdd.length} устройств`);
                    console.log(devicesByStore);
                    const fullDevices = allDevices?.filter((device) =>
                        devicesToAdd.some((d) => d === device.UID),
                    );
                    console.log(fullDevices);
                    await fetchLayouts();
                    if (layoutBool) {
                        setSelectedLayout({
                            ...layout,
                            devices: [...(layout?.devices || []), ...fullDevices],
                        });
                    }
                    setIsModalVisible(false);
                    onOk();
                }
            } else {
                message.error('Ошибка обновления раскладки: ');
            }
        } catch (error) {
            console.error('Ошибка обновления раскладки:', error);
            message.error('Произошла ошибка при обновлении раскладки.');
        } finally {
            setLoading(false);
        }
    };

    const renderTreeNodes = (data: Group[]) =>
        data.map((item) => {
            if (item.sub_groups && item.sub_groups.length) {
                return (
                    <TreeNode title={item.name} value={item.uid} key={item.uid}>
                        {renderTreeNodes(item.sub_groups)}
                    </TreeNode>
                );
            }
            return <TreeNode title={item.name} value={item.uid} key={item.uid} />;
        });
    if (!visible) return null;

    if (!layout) {
        return (
            <Modal title="Ошибка" visible={visible} onCancel={onCancel} footer={null}>
                Не удалось загрузить данные раскладки.
            </Modal>
        );
    }
    return (
        <Modal
            title={
                <div className="titleModal_Layout">
                    <span className="spanLayout">Добавить устройство</span>
                    <CloseOutlined onClick={onCancel} className="closeBut_Layout" />
                </div>
            }
            className="add-device-modal"
            visible={visible}
            onOk={handleOk}
            onCancel={onCancel}
            width={720}
            closable={false}
            footer={
                <Button className="button-size-medium button-type-primary" onClick={handleOk}>
                    Добавить
                </Button>
            }
        >
            <Form>
                <Form.Item
                    className="form_Layout"
                    label={<span className="inputLabel_Layout">Группа</span>}
                    name="group"
                    rules={[{ required: true, message: 'Пожалуйста, выберите группу' }]}
                >
                    <TreeSelect
                        className="select_group"
                        placeholder="Выберите группу"
                        onChange={handleGroupChange}
                        loading={loading}
                        treeDefaultExpandAll
                    >
                        {renderTreeNodes(groups)}
                    </TreeSelect>
                </Form.Item>
                <Form.Item
                    className="form_Group"
                    label={<span className="inputLabel_Layout">Устройство</span>}
                    name="device"
                    rules={[{ required: true, message: 'Пожалуйста, выберите устройство' }]}
                >
                    <Select
                        key={selectedDevices ? selectedDevices.join(',') : ''}
                        className="select_device"
                        placeholder="Выберите устройство"
                        disabled={!selectedGroup}
                        loading={loading}
                        mode="multiple"
                        onChange={handleDeviceChange}
                        value={selectedDevices}
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                            //@ts-ignore
                            (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {devicesByStore.map((device) => (
                            <Option
                                key={device.UID}
                                value={device.UID}
                                label={device.name}
                                disabled={existingDevices?.includes(device.UID)}
                            >
                                {device.name}
                                {existingDevices?.includes(device.UID) && ' (уже в раскладке)'}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};
